import React from 'react';
import _ from 'lodash';
import { FormControl, TextField, Typography } from '@mui/material';
import { DebounceInput } from 'react-debounce-input';

import { RequiredField } from '../others/RequiredField';
import { InfoField } from './InfoField';

export const NumberField = props => {
  const { field, formik, getFieldCallback } = props;

  return (
    <FormControl style={{ paddingBottom: 15 }} fullWidth>
      <Typography variant="subtitle1" >
        <b>{field.label}</b>
        <RequiredField required={field.required} isEmpty={!_.isNumber(formik.values[field.name])} />
      </Typography>
      <DebounceInput
        debounceTimeout={500}
        element={TextField}
        type="number"
        name={field.name}
        label={field.placeholder}
        value={formik.values[field.name]}
        onChange={formik.handleChange}
        error={formik.touched[field.name] && Boolean(formik.errors[field.name])}
        helperText={formik.touched[field.name] && formik.errors[field.name]}
        variant="standard"
      />
      {
        !_.isEmpty(field.infos)
          ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
          : null
      }
    </FormControl>
  );
};
